// import Home from "../views/Home";
const Home = r => require.ensure([], () => r(require('../views/Home')))
// import News from "../views/News";
const News = r => require.ensure([], () => r(require('../views/News')))
// import NewsArticle from "../views/NewsArticle";
const NewsArticle = r => require.ensure([], () => r(require('../views/NewsArticle')))
// import Books from "../views/Books";
const Books = r => require.ensure([], () => r(require('../views/Books')))
// import BookArticle from "../views/BookArticle";
const BookArticle = r => require.ensure([], () => r(require('../views/BookArticle')))
// import Reviews from "../views/Reviews";
const Reviews = r => require.ensure([], () => r(require('../views/Reviews')))
// import ReviewArticle from "../views/ReviewArticle";
const ReviewArticle = r => require.ensure([], () => r(require('../views/ReviewArticle')))
// import Awards from "../views/Awards";
const Awards = r => require.ensure([], () => r(require('../views/Awards')))
// import Partners from "../views/Partners";
const Partners = r => require.ensure([], () => r(require('../views/Partners')))
// import Contacts from "../views/Contacts";
const Contacts = r => require.ensure([], () => r(require('../views/Contacts')))

export default [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    title: "Главная",
    component: Home,
    meta: {
      title: "Главная",
      description: "Издательство «ГАММА-ПРЕСС» выпускает книги широкой гуманитарной тематики и принимает заказы на издание книг."
    }
  },
  {
    path: "/news",
    title: "Новости",
    component: News,
    meta: {
      title: "Новости",
      description: "Новости издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "/news/:id",
    component: NewsArticle,
    meta: {
      title: "Новость",
      description: "Новость издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "/books",
    title: "Издания",
    component: Books,
    meta: {
      title: "Издания",
      description: "Книги издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "/books/:id",
    component: BookArticle,
    meta: {
      title: "Издание",
      description: "Информация о книге издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "/reviews",
    title: "Рецензии",
    component: Reviews,
    meta: {
      title: "Рецензии",
      description: "Рецензии на книги издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "/reviews/:id",
    component: ReviewArticle,
    meta: {
      title: "Рецензия",
      description: "Рецензия на книгу издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "/awards",
    title: "Награды",
    component: Awards,
    meta: {
      title: "Награды",
      description: "Награды издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "/partners",
    title: "Партнёры",
    component: Partners,
    meta: {
      title: "Партнёры",
      description: "Партнёры издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "/contacts",
    title: "Контакты",
    component: Contacts,
    meta: {
      title: "Контакты",
      description: "Контакты издательства «ГАММА-ПРЕСС»"
    }
  },
  {
    path: "*",
    redirect: "/home"
  }
];



// WEBPACK FOOTER //
// ./client/router/routes.js